/**
 * Home bento pricing + Start Project form — keep tiers in sync here.
 */

export const LAUNCH_TIER_FEATURES = [
  "1-page conversion-focused website",
  "Includes revision rounds so we make sure it fits your needs",
  "Free hosting included—no monthly bill (unless you need more bandwidth—you can upgrade to a paid plan)",
  "Hosted on Google Cloud so you know it stays fast and reliable",
  "Ideal for startups, side hustles, or anyone who wants a credible one-page presence without the complexity.",
  "Social media links included",
];

export const SCALE_TIER_FEATURES = [
  "Unlimited pages & revisions",
  "Custom domain",
  "SEO optimization",
  "One on one support",
];

export const ENTERPRISE_TIER_FEATURES = [
  "Dedicated strategist & roadmap",
  "High-volume launches & integrations",
  "SLA-aligned support options",
  "Same-day escalation available",
];

/** Stacked cards below the featured Growth tile on Home */
export const HOME_BENTO_STACKED_CARDS = [
  {
    titleBadge: "Starter",
    priceLabel: "$150",
    priceSuffix: "Flat Fee ( Includes revision rounds )",
    features: [...LAUNCH_TIER_FEATURES],
    cta: "Start project",
  },
  {
    titleBadge: "Scale",
    priceLabel: "$5,000",
    priceSuffix: "Flat Fee ( Includes revision rounds )",
    features: [...SCALE_TIER_FEATURES],
    cta: "Talk to us",
  },
  {
    titleBadge: "Enterprise",
    priceLabel: "Starting at $10,000 and up.",
    priceSuffix: "",
    features: [...ENTERPRISE_TIER_FEATURES],
    cta: "Contact sales",
  },
];

/**
 * Radio options on /start-project (`projectType` submitted to the form API).
 * `value` stays stable for sorting/filtering inbound leads.
 */
export const START_PROJECT_SERVICE_PLANS = [
  {
    value: "growth-monthly",
    name: "Growth",
    isRecommended: true,
    features: LAUNCH_TIER_FEATURES,
    footnote: "$200 · Flat Fee ( Includes revision rounds )",
  },
  {
    value: "starter-flat",
    name: "Starter",
    isRecommended: false,
    features: LAUNCH_TIER_FEATURES,
    footnote: "$150 · Flat Fee ( Includes revision rounds )",
  },
  {
    value: "scale-flat",
    name: "Scale",
    isRecommended: false,
    features: SCALE_TIER_FEATURES,
    footnote: "$5,000 · Flat Fee ( Includes revision rounds )",
  },
  {
    value: "enterprise",
    name: "Enterprise",
    isRecommended: false,
    features: ENTERPRISE_TIER_FEATURES,
    footnote: "Starting at $10,000 and up.",
  },
];

/** Budget select — aligned with tier pricing on Home */
export const PROJECT_BUDGET_OPTIONS = [
  { value: "starter-150", label: "$150 — Starter (flat fee)" },
  { value: "growth-200-mo", label: "$200 — Growth · Flat Fee ( Includes revision rounds )" },
  { value: "scale-5000", label: "$5,000 — Scale (flat fee)" },
  { value: "enterprise-10k-plus", label: "$10,000+ — Enterprise" },
  { value: "not-sure", label: "Not sure yet / let’s discuss" },
];
